(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     NJOY Filter v2
     Pill tap → unified bottom sheet (mobile) / centered modal (desktop)
  ───────────────────────────────────────────── */

  var DESKTOP = 750;
  function isDesktop() { return window.innerWidth >= DESKTOP; }

  function applyFilters(bar) {
    var ffForm = bar.querySelector('facet-filters-form');
    if (!ffForm) return;
    var form = ffForm.querySelector('form');
    if (!form) return;
    try {
      var params = ffForm.createSearchParams(form);
      ffForm.onSubmitForm(params, null);
    } catch (e) {
      var anyInp = form.querySelector('input');
      if (anyInp) anyInp.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function snapshotCheckboxes(bar) {
    var snap = {};
    bar.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { snap[cb.id] = cb.checked; });
    return snap;
  }
  function restoreCheckboxes(bar, snap) {
    bar.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { if (cb.id in snap) cb.checked = snap[cb.id]; });
  }

  function markActiveFilters(bar) {
    bar.querySelectorAll('details.facets__disclosure').forEach(function (d) {
      var count = d.querySelectorAll('input[type="checkbox"]:checked').length;
      d.classList.toggle('active-filter', count > 0);
    });
  }

  /* ── Sort constants ─────────────────────── */
  var SORT_LABELS = {
    'best-selling':      'Bán chạy',
    'created-descending':'Mới nhất',
    'price-ascending':   'Giá tăng dần',
    'price-descending':  'Giá giảm dần'
  };
  var SORT_ALLOWED = Object.keys(SORT_LABELS);

  /* ── Mobile Unified Filter Sheet ──────────── */
  function initMobileFilterSheet(bar) {
    var overlay = document.createElement('div');
    overlay.className = 'njoy-filter-overlay';
    document.body.appendChild(overlay);

    var sheet = document.createElement('div');
    sheet.className = 'njoy-filter-sheet';
    sheet.innerHTML =
      '<div class="njoy-filter-sheet__handle"></div>' +
      '<div class="njoy-filter-sheet__header">' +
        '<span class="njoy-filter-sheet__title"></span>' +
        '<button class="njoy-filter-sheet__close" type="button" aria-label="Đóng">&#x2715;</button>' +
      '</div>' +
      '<div class="njoy-filter-sheet__body"></div>' +
      '<div class="njoy-filter-sheet__footer">' +
        '<button class="njoy-filter-btn-clear" type="button">Xoá</button>' +
        '<button class="njoy-filter-btn-apply" type="button">Áp dụng</button>' +
      '</div>';
    document.body.appendChild(sheet);

    var sheetBody  = sheet.querySelector('.njoy-filter-sheet__body');
    var titleEl    = sheet.querySelector('.njoy-filter-sheet__title');
    var closeBtn   = sheet.querySelector('.njoy-filter-sheet__close');
    var applyBtn   = sheet.querySelector('.njoy-filter-btn-apply');
    var clearBtn   = sheet.querySelector('.njoy-filter-btn-clear');
    var _snapshot  = null;
    var _currentDet = null;  /* null = sort mode; <details> = single filter mode */

    /* ─── Build pill buttons from a NodeList of checkboxes ─── */
    function buildPills(inputs, hideSwatch) {
      var wrap = document.createElement('div');
      wrap.className = 'njoy-sheet-pills';
      inputs.forEach(function (inp) {
        /* Use .facets__label (outer) — contains both swatch area and text area */
        var outerLbl = inp.closest('.facets__label');
        var textEl   = outerLbl ? outerLbl.querySelector('.facet-checkbox__text-label') : null;
        var text     = textEl ? textEl.textContent.trim() : inp.value;

        /* Brand / image swatch: look for <img> only inside .swatch to avoid false positives */
        var imgEl    = (!hideSwatch && outerLbl) ? outerLbl.querySelector('.swatch img') : null;
        /* Color / brand fallback swatch: the .swatch span with inline background-color or --swatch--background */
        var swSrc    = (!hideSwatch && !imgEl && outerLbl) ? outerLbl.querySelector('.swatch') : null;

        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'njoy-sheet-pill' + (inp.checked ? ' is-selected' : '');
        pill.setAttribute('role', 'checkbox');
        pill.setAttribute('aria-checked', String(inp.checked));

        if (imgEl) {
          var img = document.createElement('img');
          img.src = imgEl.src; img.alt = text; img.loading = 'lazy';
          pill.appendChild(img);
        } else if (swSrc) {
          var sw = document.createElement('span');
          sw.className = 'njoy-sheet-swatch';
          /* Copy all inline style (handles background-color AND --swatch--background var) */
          var inlineStyle = swSrc.getAttribute('style') || '';
          if (inlineStyle) sw.setAttribute('style', inlineStyle);
          pill.appendChild(sw);
        }

        var span = document.createElement('span');
        span.textContent = text;
        pill.appendChild(span);

        pill.addEventListener('click', function () {
          inp.checked = !inp.checked;
          pill.classList.toggle('is-selected', inp.checked);
          pill.setAttribute('aria-checked', String(inp.checked));
        });
        wrap.appendChild(pill);
      });
      return wrap;
    }

    /* ─── Sort section (sort mode only) ─── */
    function buildSortSection() {
      var sortSel = bar.querySelector('.facet-filters.sorting select');
      if (!sortSel) return null;
      var sec = createSection('');
      var list = document.createElement('div');
      list.className = 'njoy-sort-list';
      SORT_ALLOWED.forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'njoy-sort-list__item' + (sortSel.value === val ? ' is-selected' : '');
        btn.textContent = SORT_LABELS[val] || val;
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', String(sortSel.value === val));
        btn.addEventListener('click', function () {
          list.querySelectorAll('.njoy-sort-list__item').forEach(function (i) {
            i.classList.remove('is-selected');
            i.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-checked', 'true');
          sortSel.value = val;
        });
        list.appendChild(btn);
      });
      sec.appendChild(list);
      return sec;
    }

    function createSection(title) {
      var sec = document.createElement('div');
      sec.className = 'njoy-filter-section';
      if (title) {
        var h = document.createElement('div');
        h.className = 'njoy-filter-section__title';
        h.textContent = title;
        sec.appendChild(h);
      }
      return sec;
    }

    /* ─── Build sheet content for a specific context ─── */
    function buildContent(targetDet) {
      sheetBody.innerHTML = '';
      if (!targetDet) {
        /* Sort mode — show only sort options, hide Xoá */
        titleEl.textContent = 'Sắp xếp';
        clearBtn.style.display = 'none';
        applyBtn.style.flex = '1';
        var sortSec = buildSortSection();
        if (sortSec) sheetBody.appendChild(sortSec);
      } else {
        /* Filter mode — show only this pill's options */
        var nameEl = targetDet.querySelector('.facets__summary-label');
        var filterTitle = nameEl ? nameEl.textContent.trim() : 'Bộ lọc';
        titleEl.textContent = filterTitle;
        clearBtn.style.display = '';
        applyBtn.style.flex = '';
        var inputs = targetDet.querySelectorAll('input[type="checkbox"]');
        var sec = createSection('');
        var hideSwatch = filterTitle.toLowerCase() === 'thương hiệu';
        sec.appendChild(buildPills(inputs, hideSwatch));
        sheetBody.appendChild(sec);
      }
    }

    /* ─── Open / Close ─── */
    function updateOverlayTop() {
      if (isDesktop()) {
        overlay.style.top = '0px'; /* full-screen backdrop cho centered modal — thực ra bị !important CSS ghi đè, giữ để rõ ý đồ */
      } else {
        /* Math.max: nếu bar chưa sticky (chưa scroll) → dùng getBoundingClientRect() thực tế;
           nếu đang scroll (getBoundingClientRect âm / sai) → fallback về hdrH+barH */
        var hdrH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 49;
        var barH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--filter-bar-height')) || 66;
        overlay.style.top = Math.max(hdrH + barH, bar.getBoundingClientRect().bottom) + 'px';
      }
    }

    function open(targetDet) {
      updateOverlayTop();
      window.addEventListener('resize', updateOverlayTop);

      _snapshot   = snapshotCheckboxes(bar);
      _currentDet = targetDet !== undefined ? targetDet : null;
      buildContent(_currentDet);
      overlay.classList.add('is-open');
      /* Double rAF: frame 1 = layout; frame 2 = CSS transition picks up class change */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          sheet.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });
      });
    }

    function close(restoreSnap) {
      if (restoreSnap && _snapshot) { restoreCheckboxes(bar, _snapshot); markActiveFilters(bar); }
      _snapshot = null; _currentDet = null;
      sheet.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      window.removeEventListener('resize', updateOverlayTop);
    }

    closeBtn.addEventListener('click', function () { close(true); });
    overlay.addEventListener('click', function () { close(true); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) close(true);
    });

    applyBtn.addEventListener('click', function () {
      if (!_currentDet) {
        /* Sort mode: trigger Dawn sort AJAX via select input event */
        var sortSel = bar.querySelector('.facet-filters.sorting select');
        if (sortSel) sortSel.dispatchEvent(new Event('input', { bubbles: true }));
      } else {
        applyFilters(bar);
        markActiveFilters(bar);
      }
      close(false);
    });

    clearBtn.addEventListener('click', function () {
      /* Clear only the current filter's checkboxes (not all filters) */
      if (_currentDet) {
        _currentDet.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) { cb.checked = false; });
      }
      applyFilters(bar);
      markActiveFilters(bar);
      close(false);
    });

    /* Intercept: sort button → sort mode; filter pill → single filter mode */
    bar.addEventListener('click', function (e) {
      if (e.target.closest('.njoy-sort-trigger')) {
        e.preventDefault(); e.stopPropagation();
        open(null); return;
      }
      var summary = e.target.closest('summary.facets__summary');
      if (!summary) return;
      var det = summary.closest('details.facets__disclosure');
      if (!det || det.hasAttribute('data-sort-pill')) return;
      e.preventDefault();
      det.removeAttribute('open');
      open(det);
    });
  }

  /* Số SP ở tiêu đề nằm ngoài vùng Dawn vẽ lại nên phải tự cập nhật sau khi lọc */
  function initDemSP() {
    var dem = document.querySelector('.njoy-cg__count');
    var luoi = document.getElementById('ProductGridContainer');
    if (!dem || !luoi) return;
    new MutationObserver(function () {
      var c = luoi.querySelector('[data-njoy-so]');
      if (c) dem.textContent = c.getAttribute('data-njoy-so') + ' sản phẩm';
    }).observe(luoi, { childList: true });
  }

  /* ── Nút đời máy đã nhớ (Nick 04/11): khách bấm mới lọc, không tự lọc khi vào trang ── */
  function oLocMay(bar, may) {
    var form = bar.querySelector('facet-filters-form form');
    if (!form || !may) return [];
    var tat = Array.prototype.slice.call(form.querySelectorAll('input[name="filter.p.m.custom.iphne_model"]'));
    function nhan(inp) {
      var lb = inp.closest('.facets__label');
      var t = lb && lb.querySelector('.facet-checkbox__text-label');
      return (t ? t.textContent : '').replace(/\s*\(\d+\)\s*$/, '').trim().toLowerCase();
    }
    function theoTen(ten) { return tat.filter(function (i) { return nhan(i) === ten; }); }
    var dung = theoTen(may.trim().toLowerCase());
    if (dung.length) return dung;
    /* Đời gộp "iPhone 16 Pro Max/16 Pro": lọc đủ các đời trong cụm */
    return may.split('/').reduce(function (kq, p) {
      p = p.trim().toLowerCase();
      return kq.concat(theoTen(/^iphone/.test(p) ? p : 'iphone ' + p));
    }, []);
  }

  function initNutMay(bar) {
    var may = '';
    try { may = localStorage.getItem('njoyDoiMay') || ''; } catch (e) {}
    var hang = bar.querySelector('.njoy-filter-pills-scroll');
    if (!may || !hang) return;
    var td = document.querySelector('.njoy-cg__title');
    if (td && td.textContent.replace(/^\s*Phụ kiện\s*/i, '').trim().toLowerCase() === may.trim().toLowerCase()) return;

    var nut = document.createElement('button');
    nut.type = 'button';
    nut.className = 'njoy-may-chip';
    nut.textContent = may;

    function capNhat() {
      var o = oLocMay(bar, may);
      var bat = o.some(function (i) { return i.checked; });
      nut.hidden = !o.some(function (i) { return i.checked || !i.disabled; });
      nut.classList.toggle('is-on', bat);
      nut.setAttribute('aria-pressed', String(bat));
    }

    nut.addEventListener('click', function () {
      var bat = nut.classList.contains('is-on');
      oLocMay(bar, may).forEach(function (i) { if (bat || !i.disabled) i.checked = !bat; });
      capNhat();
      markActiveFilters(bar);
      applyFilters(bar);
    });

    hang.insertBefore(nut, hang.firstChild);
    capNhat();
    /* Dawn vẽ lại ô lọc sau mỗi lần lọc hoặc lùi trang */
    var luoi = document.getElementById('ProductGridContainer');
    if (luoi) new MutationObserver(function () { capNhat(); markActiveFilters(bar); }).observe(luoi, { childList: true });
  }

  /* ── Sort Pill (desktop) ─────────────────── */
  function initSortPill(bar) {
    var pill = bar.querySelector('[data-sort-pill]');
    if (!pill) return;

    pill.addEventListener('click', function (e) {
      var opt = e.target.closest('.njoy-sort-option');
      if (!opt) return;
      var val = opt.dataset.sortValue;
      var labelEl = pill.querySelector('.njoy-sort-pill__label');
      if (labelEl) labelEl.textContent = SORT_LABELS[val] || 'Sắp xếp';
      pill.querySelectorAll('.njoy-sort-option').forEach(function (o) { o.classList.remove('is-selected'); });
      opt.classList.add('is-selected');
      var sel = bar.querySelector('.facet-filters.sorting select, .facets__sort select');
      if (sel) { sel.value = val; sel.dispatchEvent(new Event('input', { bubbles: true })); }
      pill.removeAttribute('open');
    });
  }

  function updateSortPillState(bar) {
    var pill = bar.querySelector('[data-sort-pill]');
    if (!pill) return;
    var cur = new URLSearchParams(window.location.search).get('sort_by') || '';
    var labelEl = pill.querySelector('.njoy-sort-pill__label');
    if (labelEl) labelEl.textContent = SORT_LABELS[cur] || 'Sắp xếp';
    pill.querySelectorAll('.njoy-sort-option').forEach(function (o) {
      o.classList.toggle('is-selected', o.dataset.sortValue === cur);
    });
  }

  /* ── Lùi về đúng chỗ đang xem trong danh sách (Nick 01/11) ──
     SP cuộn vô hạn chỉ nằm trong DOM → Back mà trình duyệt tải lại trang thì mất hết, về đầu danh sách.
     Rời trang: lưu HTML SP đã nạp thêm + nextUrl + thẻ làm mốc (thẻ vừa bấm, không thì thẻ đầu đang thấy).
     Quay lại: gắn lại SP rồi cuộn thẻ mốc về đúng vị trí cũ. Phải đặt scrollRestoration=manual,
     không thì trình duyệt tự cuộn theo chiều cao cũ, đè lên. */
  var vtMoc = null, vtDaXet = false;
  function vtKey() { return 'njoyListPos:' + location.pathname + location.search; }

  function vtLuu() {
    var grid = document.getElementById('product-grid');
    var sentinel = document.getElementById('njoy-load-sentinel');
    if (!grid || !sentinel) return;
    var the = Array.from(grid.children);
    var moc = vtMoc && vtMoc.parentNode === grid ? vtMoc : the.find(function (li) { return li.getBoundingClientRect().bottom > 60; });
    if (!moc) return;
    var html = '';
    grid.querySelectorAll(':scope > [data-njoy-nap]').forEach(function (li) { html += li.outerHTML; });
    try {
      sessionStorage.setItem(vtKey(), JSON.stringify({ html: html, next: sentinel.dataset.nextUrl || '', idx: the.indexOf(moc), top: moc.getBoundingClientRect().top }));
    } catch (e) {
      try { sessionStorage.removeItem(vtKey()); } catch (e2) {}
    }
  }

  function vtDoc() {
    try { return JSON.parse(sessionStorage.getItem(vtKey())); } catch (e) { return null; }
  }

  function vtCuon(st) {
    var grid = document.getElementById('product-grid');
    var li = grid && grid.children[st.idx];
    if (!li) return;
    function dat() { window.scrollBy(0, li.getBoundingClientRect().top - st.top); }
    /* Ảnh, phông, thanh lọc tải xong còn xê dịch → canh lại vài lần; khách đã chạm/cuộn thì thôi */
    var dung = false;
    function thoi() { dung = true; }
    window.addEventListener('touchstart', thoi, { passive: true, once: true });
    window.addEventListener('wheel', thoi, { passive: true, once: true });
    dat();
    [0, 150, 400, 900, 1600].forEach(function (t) { setTimeout(function () { if (!dung) dat(); }, t); });
  }

  function vtKhoiPhuc(sentinel) {
    if (vtDaXet) return;
    vtDaXet = true;
    try { history.scrollRestoration = 'manual'; } catch (e) {}
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!nav || (nav.type !== 'back_forward' && nav.type !== 'reload')) return;
    var st = vtDoc();
    var grid = document.getElementById('product-grid');
    if (!st || !grid) return;
    if (st.html) {
      grid.insertAdjacentHTML('beforeend', st.html);
      sentinel.dataset.nextUrl = st.next;
    }
    vtCuon(st);
  }

  /* ── Infinite Scroll ─────────────────────── */
  function initInfiniteScroll() {
    var sentinel = document.getElementById('njoy-load-sentinel');
    if (!sentinel) return;
    vtKhoiPhuc(sentinel);
    var loading = false;
    var endMsg = sentinel.querySelector('.njoy-load-end');
    var retryBtn = null;

    /* Collection gọn trong 1 trang (không có paginate.next ngay từ đầu) —
       chưa từng fetch thêm nên nhánh "hết trang" trong load() không bao giờ
       chạy tới. Hiện thông báo ngay, không cần gắn observer. */
    if (!sentinel.dataset.nextUrl) {
      if (endMsg) endMsg.classList.add('is-visible');
      return;
    }

    function removeRetry() {
      if (retryBtn) { retryBtn.remove(); retryBtn = null; }
    }

    function showRetry() {
      removeRetry();
      retryBtn = document.createElement('button');
      retryBtn.type = 'button';
      retryBtn.className = 'njoy-load-retry';
      retryBtn.textContent = 'Không tải được sản phẩm, bấm để thử lại';
      retryBtn.addEventListener('click', load);
      sentinel.appendChild(retryBtn);
    }

    function load() {
      var nextUrl = sentinel.dataset.nextUrl;
      if (!nextUrl || loading) return;
      var cg = document.querySelector('.njoy-cg');
      if (!cg) { observer.disconnect(); return; }
      loading = true;
      removeRetry();
      var spinner = sentinel.querySelector('.njoy-load-spinner');
      if (spinner) spinner.style.display = 'block';
      fetch(nextUrl + '&section_id=' + cg.dataset.sectionId)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('#product-grid');
          var curGrid = document.getElementById('product-grid');
          if (newGrid && curGrid) {
            Array.from(newGrid.children).forEach(function (li) { li.setAttribute('data-njoy-nap', '1'); curGrid.appendChild(li); });
          }
          var newSentinel = doc.getElementById('njoy-load-sentinel');
          var newNext = newSentinel ? (newSentinel.dataset.nextUrl || '') : '';
          sentinel.dataset.nextUrl = newNext;
          if (!newNext) {
            if (endMsg) endMsg.classList.add('is-visible');
            observer.disconnect();
          }
        })
        .catch(function () { showRetry(); })
        .finally(function () {
          loading = false;
          if (spinner) spinner.style.display = 'none';
        });
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      load();
    }, { rootMargin: '400px' });
    observer.observe(sentinel);
  }

  /* ── Patch Dawn để fire facets:updated ─── */
  window.addEventListener('load', function () {
    if (typeof FacetFiltersForm === 'undefined') return;
    /* Patch renderFilters (không phải renderProductCount) vì renderFilters mới
       là lúc DOM .facets__display được rebuild xong. renderProductCount fire
       trước khi renderFilters chạy → facets:updated handler thấy DOM cũ. */
    var _origFilters = FacetFiltersForm.renderFilters;
    if (_origFilters) FacetFiltersForm.renderFilters = function (html, event) {
      _origFilters.call(this, html, event);
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('facets:updated'));
      }, 0);
    };
  });

  /* ── Update sort button label (mobile) ── */
  function updateSortBtnState(bar) {
    var btn = bar.querySelector('.njoy-filter-btn.njoy-sort-trigger');
    if (!btn) return;
    var cur = new URLSearchParams(window.location.search).get('sort_by') || '';
    var labelEl = btn.querySelector('.njoy-filter-btn__sort-label');
    if (labelEl) labelEl.textContent = SORT_LABELS[cur] || 'Sắp xếp';
    btn.setAttribute('aria-label', 'Sắp xếp theo ' + (SORT_LABELS[cur] || 'mặc định'));
  }

  /* ── Main Init ───────────────────────────── */
  function init() {
    var bar = document.querySelector('.njoy-cg__filter-bar');
    if (!bar) return;

    initMobileFilterSheet(bar);  /* universal — mọi màn hình */
    initSortPill(bar);
    initNutMay(bar);
    initDemSP();
    initInfiniteScroll();
    document.addEventListener('click', function (e) {
      var li = e.target.closest && e.target.closest('#product-grid > li');
      if (li) vtMoc = li;
      /* Lưu ngay lúc bấm link: Safari không kịp ghi sessionStorage ở pagehide khi chuyển trang */
      if (e.target.closest && e.target.closest('a[href]')) vtLuu();
    }, true);
    window.addEventListener('pagehide', vtLuu);
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;   /* Safari giữ nguyên trang: SP còn đủ, chỉ cần canh lại vị trí */
      vtMoc = null;
      var st = vtDoc();
      if (st) vtCuon(st);
    });
    updateSortBtnState(bar);
    markActiveFilters(bar);

    document.addEventListener('facets:updated', function () {
      markActiveFilters(bar);
      updateSortPillState(bar);
      updateSortBtnState(bar);
      initInfiniteScroll(); /* sentinel cũ bị Dawn renderFilters thay mới, phải gắn lại observer */
    });
  }

  /* ── Sync --header-height + --filter-bar-height ── */
  function syncHeaderHeight() {
    /* Chỉ đo phần STICKY thực sự của header.
       Dawn dùng <sticky-header> web component bọc nav — đây là element sticky.
       Announcement bar là section riêng trong .shopify-section-group-header-group
       nhưng KHÔNG sticky → không tính vào top, tránh gap 28px khi scroll. */
    var totalH = 0;
    var stickyEl = document.querySelector('sticky-header');
    if (stickyEl) {
      /* getBoundingClientRect().height: sub-pixel float, Math.floor để lấy 48px thay vì 49px */
      totalH = Math.floor(stickyEl.getBoundingClientRect().height);
    } else {
      /* Fallback: chỉ lấy element có position: sticky hoặc fixed */
      document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) {
        var pos = window.getComputedStyle(el).position;
        if (pos === 'sticky' || pos === 'fixed') totalH += el.offsetHeight;
      });
      if (!totalH) {
        var hdr = document.querySelector('.header-wrapper, header[class*="header"]');
        if (hdr) totalH = hdr.offsetHeight;
      }
    }
    if (totalH > 0) document.documentElement.style.setProperty('--header-height', totalH + 'px');

    var filterBar = document.querySelector('.njoy-cg__filter-bar');
    if (filterBar) document.documentElement.style.setProperty('--filter-bar-height', filterBar.offsetHeight + 'px');
  }

  /* ResizeObserver: tự động re-sync khi header thay đổi kích thước (ví dụ font load, banner đổi height) */
  function startResizeObserver() {
    if (!window.ResizeObserver) return;
    var ro = new ResizeObserver(syncHeaderHeight);
    document.querySelectorAll('sticky-header, .shopify-section-group-header-group').forEach(function (el) {
      ro.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncHeaderHeight(); init(); requestAnimationFrame(syncHeaderHeight);
      startResizeObserver();
    });
  } else {
    syncHeaderHeight();
    init();
    requestAnimationFrame(syncHeaderHeight); /* re-sync sau khi init render xong */
    startResizeObserver();
  }

  /* Re-sync sau khi fonts + images load xong (ảnh hưởng header height) */
  window.addEventListener('load', syncHeaderHeight, { once: true });
  window.addEventListener('resize', syncHeaderHeight, { passive: true });

})();
